import DueRepaymentCard from '@/app/pages/dashboard/components/DueRepaymentCard'
import EmiCardList from '@/app/pages/dashboard/components/EmiCardList'
import HeaderSection from '@/app/pages/dashboard/components/HeaderSection'
import LoanDetailCard from '@/app/pages/dashboard/components/LoanDetailCard'
import UpcomingRepaymentCard from '@/app/pages/dashboard/components/UpcomingRepaymentCard'

export default function getDashboardComponent(component) {
  switch (component?.type) {
    case 'header':
      return <HeaderSection data={component} key={component?.type} />
    case 'due_repayment':
    case 'payment_in_progress':
      return <DueRepaymentCard data={component} key={component?.type} />
    case 'loan_detail':
      return <LoanDetailCard data={component} key={component?.type} />
    case 'repayment_card':
      return <UpcomingRepaymentCard data={component} key={component?.type} />
    case 'list':
      return <EmiCardList data={component} key={component?.type} />
    default:
      return null
  }
}
